import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FirebaseApp } from '@angular/fire/app';
import { createUserWithEmailAndPassword, getAuth, sendEmailVerification, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { StorageService } from 'src/app/services/common/storage';
import { LogInSuccess, LogInFailure } from 'src/app/store/actions/auth.actions';
import { AppState, selectAuthState } from 'src/app/store/app.states';
import { MatchPasswordValidatorProvider } from 'src/app/match-password-validator/match-password-validator';
import { RegistrationService } from 'src/app/services/registration/registration.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  public showSpinner: boolean;
  public submitted: boolean = false;
  public submitFormName: string;
  public state: any;
  public message: string;
  passForm;
  signUpForm: FormGroup;
  public loginStudentForm: FormGroup;
  public loginTeacherForm: FormGroup;

  constructor(private afApp: FirebaseApp,
    protected localStorage: StorageService,
    private readonly router: Router,
    public registrationService: RegistrationService,
    public fb: FormBuilder,
    private store: Store<AppState>,
    public storage: StorageService) {

    this.passForm = this.fb.group({
      confimpassword: ['', {
        validators: Validators.required,
        asyncValidators: [MatchPasswordValidatorProvider.matchPassword]

      }],
      password: ['', {
        validators: [Validators.compose([Validators.required, Validators.minLength(6), Validators.minLength(2)])]
      }]
    });

    this.signUpForm = new FormGroup({
      email: new FormControl(
        '',
        [
          Validators.required,
          Validators.email,
        ]),
      enableCode: new FormControl(
        '',
        [
          Validators.required,
        ]),
      matching_password: this.passForm,

      remember: new FormControl(
        ''),
    });
  }

  ngOnInit() {

  }

  pop() {
    Swal.fire(
      'Compte crée!',
      'Un mail vous a été envoyé, veuillez confirmer votre mail pour utiliser votre compte.',
      'success'
    )
  }

  private async signUp(code, email, password) {

    //this.registrationService.deleteDocument("code");
    const auth = getAuth(this.afApp);

       this.registrationService.checkCode(code, email)
      .then(x => {
        if (x.check) {
          createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
             
              sendEmailVerification(userCredential.user)
                .then(() => {
                  this.pop();
                  this.showSpinner = false;
                });
              var user = x.data;
              user['uid'] = userCredential.user.uid;
             console.log(user);
              //this.registrationService.writeUserData(user);

            })
            .catch((error) => {
              this.showSpinner = false;
              const errorCode = error.code;
              const errorMessage = error.message;
              // ..
            });
        }
        this.showSpinner = false;
      });
     


   

  }


  /**
   * Login
   * @returns 
   */
  onSubmit() {
    this.showSpinner = true;
    const email = this.signUpForm.value.email;
    const code = this.signUpForm.value.enableCode;
    const password = this.signUpForm.value.matching_password.password;

    if (this.signUpForm.invalid) {

      if (password < 6) {
        this.message = "Choisissez un mot de passe de taille minimum 6";
      }
      else {
        this.message = "Les mots de passent ne sont pas identiques.";
      }

      // return;
    }
 
    this.message = "";
    this.signUp(code, email, password);

  }

}
